import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  const now = new Date();
  return yield oncallFetch("/api/oncall/partners/regions/schedule-status", {
    now: now.getTime(),
    utcOffset: now.getTimezoneOffset(),
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/schedule-status.js